import script from "./ServiceDeleteModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./ServiceDeleteModal.vue?vue&type=script&setup=true&lang=ts"

import "./ServiceDeleteModal.vue?vue&type=style&index=0&id=9da5ca2a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9da5ca2a"]])

export default __exports__